<template>
    <img src="/images/promo/hero-section/magic-wand.png"
     alt="Magic wand" />
</template>

<script>
export default {};
</script>
